// extracted by mini-css-extract-plugin
export default {"fullscreen":"style_fullscreen__LH-sM"};